import { render, staticRenderFns } from "./LayoutContentRendererPDF.vue?vue&type=template&id=6b178ca2&"
import script from "./LayoutContentRendererPDF.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports